import routerConstants from '@/constants/routerConstants'
import {
  nhomKhachHangUiTestFeatureCount,
  runNhomKhachHangUiTest,
} from '@/modules/ui-test/scenarios/nhomKhachHangUiTest'
import { getEntityUiTestFeatureCount, runEntityUiTest } from '@/modules/ui-test/scenarios/createEntityUiTest'
import { ENTITY_UI_TEST_MODULES } from '@/modules/ui-test/scenarios/entityUiTestConfigs'
import { UI_TEST_RUN_QUERY } from '@/modules/ui-test/uiTestSession'
import type { UiTestScenarioId, UiTestScenarioSummary } from '@/modules/ui-test/uiTest.types'
import type { UiTestRunner } from '@/modules/ui-test/utils/uiTestRunner'

export type UiTestScenarioConfig = {
  id: UiTestScenarioId
  targetPath: string
  featureCount: number
  run: (uiTest: UiTestRunner) => Promise<UiTestScenarioSummary>
}

const entityScenarios = Object.fromEntries(
  ENTITY_UI_TEST_MODULES.map((cfg) => [
    cfg.scenarioId,
    {
      id: cfg.scenarioId,
      targetPath: cfg.listPath,
      featureCount: getEntityUiTestFeatureCount(cfg),
      run: (uiTest: UiTestRunner) => runEntityUiTest(cfg, uiTest),
    } satisfies UiTestScenarioConfig,
  ]),
) as Record<string, UiTestScenarioConfig>

export const UI_TEST_SCENARIOS: Record<UiTestScenarioId, UiTestScenarioConfig> = {
  ...entityScenarios,
  'nhom-khach-hang': {
    id: 'nhom-khach-hang',
    targetPath: routerConstants.nhomKhachHang.list,
    featureCount: nhomKhachHangUiTestFeatureCount,
    run: runNhomKhachHangUiTest,
  },
} as Record<UiTestScenarioId, UiTestScenarioConfig>

export function getUiTestScenario(id: string | null | undefined): UiTestScenarioConfig | null {
  if (!id) return null
  return UI_TEST_SCENARIOS[id as UiTestScenarioId] ?? null
}

export function buildUiTestTargetUrl(scenarioId: UiTestScenarioId): string {
  const scenario = UI_TEST_SCENARIOS[scenarioId]
  if (!scenario?.targetPath) {
    throw new Error(`UI test scenario chưa đăng ký: ${scenarioId}`)
  }
  const qs = new URLSearchParams({ [UI_TEST_RUN_QUERY]: scenarioId })
  return `${scenario.targetPath}?${qs.toString()}`
}
